export { default } from './StyledCard';